type GetStringOrEmpty = {
  value?: string
  prefix?: string
  suffix?: string
}
export const getStringOrEmpty = ({ value, prefix, suffix }: GetStringOrEmpty): string => {
  if (!value) return ''
  return `${getStringOrEmpty({ value: prefix })}${value}${getStringOrEmpty({ value: suffix })}`
}
